import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { MyStore } from './redux/helpers/store';
import App from './App';
import { SSR } from './utils/config';

// console.log(window.REDUX_DATA)
const store = MyStore();
const doc = typeof document === 'undefined' ? '' : document;
const app = doc.getElementById('root');
const jsx = (
    <Provider store={store}>
        <BrowserRouter>
            <App found={false} />
        </BrowserRouter>
    </Provider>
);

const renderMethod = SSR ? ReactDOM.hydrate : ReactDOM.render;
renderMethod(jsx, app);
